var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.952 0c2.2 0 4.076.775 5.627 2.326 1.55 1.55 2.326 3.426 2.326 5.626a7.96 7.96 0 0 1-.338 2.287 7.093 7.093 0 0 1-1.014 2.087l5.01 5.01c.291.292.437.663.437 1.113 0 .45-.146.822-.437 1.114-.292.291-.663.437-1.114.437-.45 0-.821-.146-1.113-.437l-5.01-5.01a7.093 7.093 0 0 1-2.087 1.014 7.96 7.96 0 0 1-2.287.338c-2.2 0-4.075-.776-5.626-2.326C.776 12.028 0 10.152 0 7.952c0-2.2.775-4.075 2.326-5.626C3.876.776 5.752 0 7.952 0zm0 2.152c-1.61 0-2.98.564-4.108 1.692C2.716 4.972 2.152 6.34 2.152 7.952c0 1.611.564 2.98 1.692 4.109 1.128 1.127 2.497 1.691 4.108 1.691 1.611 0 2.98-.564 4.109-1.691 1.127-1.128 1.691-2.498 1.691-4.109 0-1.61-.564-2.98-1.691-4.108-1.128-1.128-2.498-1.692-4.109-1.692zM11.1 5.5c.22 0 .4.18.4.4v5.4a.4.4 0 0 1-.4.4h-.8a.4.4 0 0 1-.4-.4V5.9c0-.22.18-.4.4-.4h.8zM8.5 3.6c.22 0 .4.18.4.4v7.3a.4.4 0 0 1-.4.4h-.8a.4.4 0 0 1-.4-.4V4c0-.22.18-.4.4-.4h.8zM5.9 7.9c.22 0 .4.18.4.4v3a.4.4 0 0 1-.4.4h-.8a.4.4 0 0 1-.4-.4v-3c0-.22.18-.4.4-.4h.8z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.6a6a74fb0d4d2cc9195eb6c5ab95fd51.svg";
export { ForwardRef as ReactComponent };